import trunkPain from './symptom groups/trunkPain.js'
import bonePain from './symptom groups/bonepain.js'
import nonSpecPain from './symptom groups/nonspecpain.js'
import alcLnPain from './symptom groups/alcLnPain.js'
import weightLoss from './symptom groups/weightloss.js'
import duration from './symptom groups/duration.js'
import fever from './symptom groups/fever.js'
import siteAndDuration from './symptom groups/siteandduration.js'
import lymphNode from './symptom groups/lymphnode.js'
import jaundice from './symptom groups/jaundice.js'
import diabetes from './symptom groups//diabetes.js'
import dvt from './symptom groups/dvt.js'
import childConcern from './symptom groups/childConcern.js'
import mass from './symptom groups/mass.js'
import massWithAbdoSite from './symptom groups/massWithAbdoSite.js'
import massWithSide from './symptom groups/massWithSide.js'
import ascites from './symptom groups/ascites.js'
import dysphagia from './symptom groups/dysphagia.js'
import haematemesis from './symptom groups/haematemesis.js'
import rectalBleeding from './symptom groups/rectalBleeding.js'
import cobh from './symptom groups/cobh.js'
import rectalMass from './symptom groups/rectalMass.js'
import freqAndDuration from './symptom groups/freqAndDuration.js'
import freqAndUrgency from './symptom groups/freqAndUrgency.js'
import hesRetNocturia from './symptom groups/hesRetNocturia.js'
import haematuria from './symptom groups/haematuria.js'
import microHaematuria from './symptom groups/microHaematuria.js'
import prostate from './symptom groups/prostate.js'
import ed from './symptom groups/ed.js'
import testisSize from './symptom groups/testisSize.js'
import testisAbnormal from './symptom groups/testisAbnormal.js'
import sideDescriptionDuration from './symptom groups/SideDescriptionDuration.js'
import sti from './symptom groups/sti.js'
import penileMass from './symptom groups/penileMass.js'
import foreskin from './symptom groups/foreskin.js'
import vaginalDischarge from './symptom groups/vaginalDischarge.js'
import vaginalBleeding from './symptom groups/vaginalBleeding.js'
import description from './symptom groups/description.js'
import vulval from './symptom groups/vulval.js'
import smoker from './symptom groups/smoker.js'
import asbestos from './symptom groups/asbestsos.js'
import haemoptysis from './symptom groups/haemoptysis.js'
import cough from './symptom groups/cough.js'
import clubbing from './symptom groups/clubbing.js'
import neckNodes from './symptom groups/neckNodes.js'
import sob from './symptom groups/sob.js'
import lungSigns from './symptom groups/lungSigns.js'
import pleural from './symptom groups/pleural.js'
import breastLump from './symptom groups/breastLump.js'
import nippleDischarge from './symptom groups/nippleDischarge.js'
import nippleRetraction from './symptom groups/nippleRetraction.js'
import breastSkin from './symptom groups/breastSkin.js'
import axillaLump from './symptom groups/axillalump.js'
import dermoscopy from './symptom groups/dermoscopy.js'
import pigmented from './symptom groups/pigmented.js'
import skinLesion from './symptom groups/skinLesion.js'
import skinNoSize from './symptom groups/skinNoSize.js'
import siteDescriptionDuration from './symptom groups/siteDescriptionDuration.js'
import hoarse from './symptom groups/hoarse.js'
import mouthMass from './symptom groups/mouthMass.js'
import leukoplakia from './symptom groups/leukoplakia.js'
import thyroid from './symptom groups/thyroid.js'
import cns from './symptom groups/cns.js'
import squint from './symptom groups/squint.js'
import redReflex from './symptom groups/redReflex.js'
import headache from './symptom groups/headache.js'
import labTestQuestions from './symptom groups/labTestQuestions.js'
import ida from './symptom groups/ida.js'
import fit from './symptom groups/fit.js'
import imagingQuestions from './symptom groups/imagingQuestions.js'
import dyspepsia from './symptom groups/dyspepsia.js'
import bleeding from './symptom groups/bleeding.js'





const extraSymptomsIndex =
{
bonePain: bonePain,   
trunkPain: trunkPain,
nonSpecPain: nonSpecPain,
alcLnPain: alcLnPain,
weightLoss: weightLoss,
duration: duration,
fever: fever,
siteAndDuration: siteAndDuration,
bleeding: bleeding,
lymphNode: lymphNode,
jaundice: jaundice,
diabetes: diabetes,
dvt: dvt,
childConcern: childConcern,
mass: mass,
massWithAbdoSite: massWithAbdoSite,
massWithSide: massWithSide,
ascites: ascites,
dysphagia: dysphagia,
dyspepsia:dyspepsia,
haematemesis: haematemesis,
rectalBleeding: rectalBleeding,
cobh: cobh,
rectalMass: rectalMass,
freqAndDuration:freqAndDuration,
freqAndUrgency: freqAndUrgency,
hesRetNocturia:hesRetNocturia,
haematuria: haematuria,
microHaematuria: microHaematuria,
prostate: prostate,
ed: ed,
testisSize: testisSize,
testisAbnormal: testisAbnormal,
sideDescriptionDuration: sideDescriptionDuration,
sti: sti,
penileMass: penileMass,
foreskin: foreskin,
vaginalDischarge: vaginalDischarge,
vaginalBleeding: vaginalBleeding,
description: description,
vulval: vulval,
smoker: smoker,
asbestos: asbestos,
haemoptysis: haemoptysis,
cough: cough,
clubbing: clubbing,
neckNodes: neckNodes,
sob: sob,
lungSigns: lungSigns,
pleural: pleural, 
breastLump: breastLump,
nippleDischarge: nippleDischarge,
nippleRetraction: nippleRetraction,
breastSkin: breastSkin,
axillaLump: axillaLump,
pigmented: pigmented,
dermoscopy: dermoscopy,
skinLesion: skinLesion,
skinNoSize: skinNoSize,
siteDescriptionDuration: siteDescriptionDuration,
hoarse: hoarse,
mouthMass: mouthMass,
leukoplakia: leukoplakia,
thyroid: thyroid,
cns: cns,
squint: squint,
redReflex: redReflex,
headache: headache,
labTestQuestions: labTestQuestions,
ida: ida,
fit: fit,
imagingQuestions: imagingQuestions


}


export default extraSymptomsIndex